<div class="zs-master-style" *ngIf="identifier?.value?.length > 0">
    <h6> {{identifier.key}}: </h6>
    <span class="zs-margin-0-0-1-0" *ngFor="let val of identifier.value; let i=index">
      <span class="zs-margin-0-0-0-1" *ngIf="i > 0 && i < identifier.value.length">
        ,
      </span>
      {{val}}
    </span>
</div>